export const validation = {
  headingMaxChar: 50,
  paragraphMaxChar: 100,
  blockTitleMaxChar: 30,
  blockParagraphMaxChar: 100,
  blocks: {
    min: 3,
    max: 12
  }
}